















































































































































































































































































































































































































































import BaseComponent from '@/components/BaseComponent';
import Button from '@/components/Button/Button.vue';
import Dropdown from '@/components/Dropdown/Dropdown.vue';
import Modal from '@/components/Modal/Modal.vue';
import NSPTable from '@/components/Table/NSPTable.vue';
import { INSPTableEvent } from '@/components/Table/typing/table-event.interface';
import { NSPTableSettings } from '@/components/Table/typing/table-settings';
import { miscTypes } from '@/store/modules/misc/miscTypes';
import { Contractor } from '@/typing/api/contractor.class';
import { Ship } from '@/typing/api/ship.class';
import { getState } from '@/utils/vueInstance';
import Component from 'vue-class-component';
import { User } from '@/typing/api/user.class';
import Role, { readableRole } from '@/typing/enums/role.enum';
import showNotification from '@/utils/notification';
import { projectTypes } from '@/store/modules/project/projectTypes';
import {
  putContractor,
  postContractor,
  putShip,
  postShip,
  deleteContractor,
  deleteShip,
  userPasswordReset,
  postUser,
  putUser,
  deleteUser,
} from '@/api/manage';
import MaterialIcon from '@/typing/enums/materialIcon.enum';
import { shipTypesDropdownValues } from '@/utils/shipTypes';

@Component({
  components: {
    NSPTable,
    Button,
    Modal,
    Dropdown,
  },
})
export default class Manage extends BaseComponent {
  get userModalRef(): Modal | null {
    const ref = this.$refs.userModal;
    return ref ? (ref as Modal) : null;
  }

  get confirmModal(): Modal | null {
    const ref = this.$refs.confirmModal;
    return ref ? (ref as Modal) : null;
  }

  get shipModal(): Modal | null {
    const ref = this.$refs.shipModal;
    return ref ? (ref as Modal) : null;
  }

  get userModal(): Modal | null {
    const ref = this.$refs.userModal;
    return ref ? (ref as Modal) : null;
  }

  get contractorModal(): Modal | null {
    const ref = this.$refs.contractorModal;
    return ref ? (ref as Modal) : null;
  }

  toEditUser?: User = new User();
  showEditUserModal = false;

  toEditContractor: Contractor = new Contractor();
  showEditContractorModal = false;

  toEditShip: Ship = new Ship();
  showEditShipModal = false;

  shipTypes: any[] = shipTypesDropdownValues;

  roles = [
    { label: 'Schipper', value: Role.Skipper },
    { label: 'Aannemer', value: Role.Contractor },
    { label: 'Opdrachtgever', value: Role.Client },
  ];

  toConfirmItem: { item: any; text: string; apiCall: any } | null = null;

  roleEnum = Role;

  get users(): any[] {
    return getState().misc.users;
  }

  get contractors(): Contractor[] {
    return getState().project.projectData?.contractors ?? [];
  }

  get ships(): Ship[] {
    return getState().project.projectData?.ships ?? [];
  }

  get availableContractors(): Contractor[] {
    const currentSelectedContractor =
      this.toEditUser?.appMetadata?.contractorId ?? -1;

    const contractors = this.contractors;
    const contractorUsers = this.users.filter(
      (x) => x.role === Role.Contractor
    );
    const usedContractorsIds = contractorUsers.map((x) =>
      x.appMetadata.contractorId.toString()
    );

    const available = contractors.filter(
      (x) =>
        !usedContractorsIds.includes(x.id.toString()) ||
        x.id.toString() === currentSelectedContractor.toString()
    );

    return available;
  }

  get currentContractor(): Contractor | null {
    const currentSelectedContractor =
      this.toEditUser?.appMetadata?.contractorId ?? -1;

    if (currentSelectedContractor === -1) {
      return null;
    }

    return (
      this.contractors.find(
        (x) => (x.id as any) == (currentSelectedContractor as any)
      ) ?? ({ name: 'Verwijderd' } as any)
    );
  }

  get currentShip(): Ship | null {
    const currentShip = this.toEditUser?.appMetadata?.shipId ?? -1;

    if (currentShip === -1) {
      return null;
    }

    return (
      this.ships.find((x) => (x.id as any) == (currentShip as any)) ??
      ({ name: 'Verwijderd' } as any)
    );
  }

  get availableShips(): Ship[] {
    const currentSelectedShip = this.toEditUser?.appMetadata?.shipId ?? -1;

    const ships = this.ships;
    const skippers = this.users.filter((x) => x.role === Role.Skipper);
    const usedContractorsIds = skippers.map((x) =>
      x.appMetadata.shipId.toString()
    );

    const available = ships.filter(
      (x) =>
        !usedContractorsIds.includes(x.id.toString()) ||
        x.id.toString() === currentSelectedShip.toString()
    );

    return available;
  }

  userTable = new NSPTableSettings({ itemsPerPage: 10, showPagination: true })
    .addColumn({ label: 'Naam', valueKey: 'name' })
    .addColumn({ label: 'E-mail', valueKey: 'email' })
    .addColumn({ label: 'Rol', valueKey: 'role', formatFn: readableRole })
    .addAction({
      name: 'Password reset',
      id: 'user-reset-password',
      isAvailable: () => true,
    })
    .addAction({
      iconName: MaterialIcon.Edit,
      id: 'edit-user',
      isAvailable: () => true,
    })
    .addAction({
      iconName: MaterialIcon.Delete,
      id: 'delete-user',
      isAvailable: () => true,
    });

  contractorTable = new NSPTableSettings({
    itemsPerPage: 10,
    showPagination: true,
  })
    .addColumn({ label: 'Naam', valueKey: 'name' })
    .addAction({
      iconName: MaterialIcon.Edit,
      id: 'edit-contractor',
      isAvailable: () => true,
    })
    .addAction({
      iconName: MaterialIcon.Delete,
      id: 'delete-contractor',
      isAvailable: () => true,
    });

  shipTable = new NSPTableSettings({ itemsPerPage: 10, showPagination: true })
    .addColumn({ label: 'Naam', valueKey: 'name' })
    .addColumn({ label: 'Type', valueKey: 'type' })
    .addColumn({
      label: 'Aannemer',
      valueKey: 'contractorId',
      formatFn: (val: number) => {
        const contractor = this.contractors.find((x) => x.id === val);
        if (!contractor) {
          return 'Verwijderd';
        }
        return contractor.name;
      },
    })
    .addAction({
      iconName: MaterialIcon.Edit,
      id: 'edit-ship',
      isAvailable: () => true,
    })
    .addAction({
      iconName: MaterialIcon.Delete,
      id: 'delete-ship',
      isAvailable: () => true,
    });

  async mounted(): Promise<void> {
    this._genericInit(true);
    this._setPageName('Beheer');

    if (this.isClient()) {
      this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
        label: 'Projecten',
        active: false,
        navPath: '/projects',
      });
      this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
        label: 'Rapporten',
        active: false,
        navPath: '/reports',
      });
      this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
        label: 'Exporteren',
        active: false,
        navPath: '/export',
      });
      this.$store.dispatch(miscTypes.actions.ADD_HEADER_NAV_LINK, {
        label: 'Beheer',
        active: true,
        navPath: '/manage',
      });
    } else {
      this.$router.push('/');
    }

    await this.$store.dispatch(miscTypes.actions.FETCH_USERS);
  }

  async onConfirmDelete(): Promise<void> {
    try {
      this._toggleLoader();
      await this.toConfirmItem?.apiCall(this.toConfirmItem.item);
      this.confirmModal?.closeModal();

      if (this.toConfirmItem?.text.toLowerCase().includes('gebruiker')) {
        await this.$store.dispatch(miscTypes.actions.FETCH_USERS);
        this.$forceUpdate();
      } else {
        this._updateData();
      }

      showNotification('Verwijderen is gelukt.');
      this.toConfirmItem = null;
    } catch (error) {
      showNotification('Er is iets fout gegaan tijdens het verwijderen.');
    } finally {
      this._toggleLoader();
    }
  }

  onRejectDelete(): void {
    (this.$refs.confirmModal as Modal).closeModal();
    this.toConfirmItem = null;
  }

  async handleTableEvent(e: INSPTableEvent): Promise<void> {
    if (e.actionID === 'edit-user') {
      this.toEditUser = new User(e.item);
      this.showEditUserModal = true;
    }

    if (e.actionID === 'delete-user') {
      this.toConfirmItem = {
        item: e.item,
        text: `Weet je het zeker dat je deze gebruiker (${e.item.email}) wilt verwijderen?`,
        apiCall: (item: any) => deleteUser(item),
      };
    }

    if (e.actionID === 'edit-contractor') {
      this.toEditContractor = new Contractor(e.item);
      this.showEditContractorModal = true;
    }

    if (e.actionID === 'delete-contractor') {
      this.toConfirmItem = {
        item: e.item,
        text: 'Weet je het zeker dat je deze aannemer wilt verwijderen?',
        apiCall: (item: any) => deleteContractor(item),
      };
    }

    if (e.actionID === 'edit-ship') {
      this.toEditShip = new Ship(e.item);
      this.showEditShipModal = true;
    }

    if (e.actionID === 'delete-ship') {
      this.toConfirmItem = {
        item: e.item,
        text: 'Weet je het zeker dat je dit schip wilt verwijderen?',
        apiCall: (item: any) => deleteShip(item),
      };
    }

    if (e.actionID === 'user-reset-password') {
      this._toggleLoader();
      try {
        await userPasswordReset(e.item);
        showNotification(
          `Een mail zal verstuurd worden naar de gebruiker, met een link om het password aan te passen.`
        );
      } catch (error) {
        showNotification(
          'Er ging iets fout tijdens het versturen van de mail, probeer het later opnieuw.'
        );
      } finally {
        this._toggleLoader();
      }
    }

    this.$forceUpdate();
  }

  onUserModalClose(): void {
    this.toEditUser = new User();
    this.showEditUserModal = false;
  }

  async submitUser(): Promise<void> {
    if (!this.toEditUser) return;

    if (!this.toEditUser.validate().isValid) {
      return;
    }

    this._toggleLoader();
    try {
      if (this.toEditUser.auth0UserID) {
        await putUser(this.toEditUser);
      } else {
        await postUser(this.toEditUser);
      }
      this.userModalRef?.closeModal();
      showNotification('Gebruiker opgeslagen.');
      await this.$store.dispatch(miscTypes.actions.FETCH_USERS, {
        showLoader: false,
      });
    } catch (error) {
      showNotification(
        'Er is iet misgegaan met het opslaan van de gebruiker, probeer het later opnieuw.'
      );
    } finally {
      this._toggleLoader();
    }
  }

  onContractorModalClose(): void {
    this.toEditContractor = new Contractor();
    this.showEditContractorModal = false;
  }

  async submitContractor(): Promise<void> {
    if (!this.toEditContractor.validate().isValid) {
      return;
    }

    this._toggleLoader();
    try {
      if (this.toEditContractor.id > -1) {
        await putContractor(this.toEditContractor);
      } else {
        await postContractor(this.toEditContractor);
      }

      this.contractorModal?.closeModal();
      showNotification('Aannemer opgeslagen.');
      this._updateData();
    } catch (error) {
      console.error(error);
    } finally {
      this._toggleLoader();
    }
  }

  onShipModalClose(): void {
    this.toEditShip = new Ship();
    this.showEditShipModal = false;
  }

  async submitShip(): Promise<void> {
    if (!this.toEditShip.validate().isValid) {
      return;
    }

    this._toggleLoader();
    try {
      if (this.toEditShip.id > -1) {
        await putShip(this.toEditShip);
      } else {
        await postShip(this.toEditShip);
      }
      this.shipModal?.closeModal();
      showNotification('Schip opgeslagen.');
      this._updateData();
    } catch (error) {
      console.error(error);
    } finally {
      this._toggleLoader();
    }
  }

  private async _updateData(): Promise<void> {
    await this.$store.dispatch(projectTypes.actions.FETCH_PROJECT_DATA, {
      skipBoxData: true,
    });
    this.$forceUpdate();
  }
}
